export function formatKES(value: number | string | null | undefined, withDecimals = false): string {
  const amount = Number(value ?? 0);
  return `KSh ${amount.toLocaleString("en-KE", {
    minimumFractionDigits: withDecimals ? 2 : 0,
    maximumFractionDigits: withDecimals ? 2 : 0,
  })}`;
}

export function vehicleTitle(make: string, model: string, year?: number | null): string {
  return year ? `${year} ${make} ${model}` : `${make} ${model}`;
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-KE", { day: "numeric", month: "short", year: "numeric" });
}